import type { Config } from '@/config/types.ts'; // 预生产环境配置

// 预生产环境配置
const config: Partial<Config> = {};

export default config;
